import "./tab03.css";
import MasterForm from "../../../components/MasterForm/MasterForm"


const tab03 = ({onEditingChange}) => {
    return (
        <div>
            <MasterForm onEditingChange={onEditingChange} className="MasterForm" />
        </div>
    );
};

export default tab03;